import styled from "styled-components";
import {Button} from "@material-ui/core";

import {SectionTabs} from "components/SectionTabs";

export const Container = styled.div`
  padding: 0.5rem;
  background-color: #fff;
  max-width: 900px;
  margin: 0 auto;
  border: 1px solid #0B4598;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  
  @media(min-width: 465px) {
    padding: 1rem;
  }
  
  @media(min-width: 768px) {
    padding: 1.5rem;
  }
`

export const StyledSectionTabs = styled(SectionTabs)`
  margin: 0.75rem 0;
  
  @media(min-width: 465px) {
    margin: 1.5rem 0;
  }
  
  @media(min-width: 768px) {
    margin: 2rem 0;
  }
`

export const PopupContainer = styled.div`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
`

export const PopupTitle = styled.div`
  margin-bottom: 1.75rem;
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: 600;
`

export const PopupDescription = styled.div`
  margin-bottom: 1.75rem;
  line-height: 1.5;
`

export const PopupButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
`

export const PopupButton = styled(Button)`
  flex: 1;
  min-width: 0;
  min-height: 48px;
`
